import React from 'react';
import ReactDOM from 'react-dom';
import { MapModuleButton } from 'oskari-frontend/bundles/mapping/mapmodule/MapModuleButton';
import { GlobalOutlined } from '@ant-design/icons';
import { showProjectionChangePopup } from './ProjectionChangePopup';
import { showProjectionPopup } from './ProjectionCard';
Oskari.clazz.define('Oskari.projection.change.ProjectionChangerPlugin', function (options, localization) {
  this.options = options || {};
  this._clazz = 'Oskari.projection.change.ProjectionChangerPlugin';
  this._defaultLocation = 'top right';
  this._index = 55;
  this._templates = {
    projectionchanger: jQuery('<div class="mapplugin oskari-projection-changer"></div>')
  };
  this._loc = localization;
  this._log = Oskari.log('Oskari.projection.change.ProjectionChangerPlugin');
  this.popupControls = null;
  this.projectionCard = null;
}, {
  popupCleanup: function popupCleanup() {
    if (this.popupControls) {
      this.popupControls.close();
    }
    this.popupControls = null;
    this.renderButton();
  },
  cardCleanup: function cardCleanup() {
    if (this.projectionCard) {
      this.projectionCard.close();
    }
    this.projectionCard = null;
  },
  showPopup: function showPopup() {
    var _this = this;
    if (!this.popupControls) {
      this.popupControls = showProjectionChangePopup(this.options.views, function (uuid, srsName) {
        return _this.changeProjection(uuid, srsName);
      }, Oskari.getSandbox().getMap().getSrsName(), function (imgUrl, srsName) {
        return _this.showCard(imgUrl, srsName);
      }, function () {
        return _this.popupCleanup();
      });
    } else {
      this.popupCleanup();
    }
    this.renderButton();
  },
  showCard: function showCard(imgUrl, srsName) {
    var _this2 = this;
    if (this.projectionCard) {
      this.cardCleanup();
    }
    this.projectionCard = showProjectionPopup(imgUrl, srsName, function () {
      return _this2.cardCleanup();
    });
  },
  /**
   * @method changeProjection
   * @description reloads the page with a new uuid
   */
  changeProjection: function changeProjection(uuid, srs) {
    if (!uuid) {
      return;
    }
    var url = window.location.origin;
    if (window.location.pathname && window.location.pathname.length) {
      url += window.location.pathname;
    }
    url += '?uuid=' + uuid;
    url += this.getSelectedMapLayersUrlParam();
    window.location.href = url;
  },
  getSelectedMapLayersUrlParam: function getSelectedMapLayersUrlParam() {
    var maplayerUrlString = '&mapLayers=';
    var layerString = '';
    var layers = this.options.sb.getMap().getLayers();
    if (layers.length === 0) {
      return;
    }
    layers.forEach(function (layer) {
      if (layerString !== '') {
        layerString += ',';
      }
      layerString += layer._id + '+' + layer._opacity;
      if (layer.style) {
        layerString += '+' + layer.style;
      } else {
        layerString += '+';
      }
    });
    maplayerUrlString += layerString;
    return maplayerUrlString;
  },
  _createControlElement: function _createControlElement() {
    return this._templates.projectionchanger.clone();
  },
  renderButton: function renderButton(element) {
    var _this3 = this;
    var el = element;
    if (!element) {
      el = this.getElement();
    }
    ;
    if (!el) return;
    ReactDOM.render(/*#__PURE__*/React.createElement(MapModuleButton, {
      icon: /*#__PURE__*/React.createElement(GlobalOutlined, null),
      iconSize: "24px",
      onClick: function onClick() {
        return _this3.showPopup();
      },
      iconActive: !!this.popupControls,
      title: this._loc.tooltip.tool
    }), el[0]);
  },
  createUi: function createUi() {
    if (this.getElement()) {
      return;
    }
    this._element = this._createControlElement();
    this.renderButton(this._element);
    this.addToPluginContainer(this._element);
  },
  /**
  * Handle plugin UI and change it when desktop / mobile mode
  * @method  @public redrawUI
  * @param  {Boolean} mapInMobileMode is map in mobile mode
  * @param {Boolean} forced application has started and ui should be rendered with assets that are available
  */
  redrawUI: function redrawUI() {
    if (this.getElement()) {
      this.teardownUI(true);
    }
    this.createUi();
  },
  teardownUI: function teardownUI(stopping) {
    // detach old element from screen
    this.getElement().detach();
    this.removeFromPluginContainer(this.getElement());
  },
  getElement: function getElement() {
    return this._element;
  },
  stopPlugin: function stopPlugin() {
    this.teardownUI(true);
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});